import React from 'react';
import { useIntl } from 'react-intl';

import {
  Container,
  CenterSection,
  ErrorIconCircle,
  Title,
  TextStack,
  Strong,
} from './styles';
import { CheckErrorIcon } from '../../../components/Icons';

function SessionExpired() {
  const intl = useIntl();

  return (
    <Container>
      <CenterSection>
        {/* Error Icon */}
        <ErrorIconCircle>
          <CheckErrorIcon />
        </ErrorIconCircle>

        {/* Error Message */}
        <div style={{ marginBottom: '2rem' }}>
          <Title>{intl.messages['session.terminated.title']}</Title>
          <TextStack>
            {intl.messages['session.terminated.instruction']}{' '}
            <Strong>
              {intl.messages[`session.terminated.instruction.reason.${new URLSearchParams(window.location.search).get('type') || 'refresh'}`]}
            </Strong>{' '}
            {intl.messages['session.terminated.reason']}
            <br />
            <br />
            {intl.messages['session.terminated.nextstep']}
          </TextStack>
        </div>
      </CenterSection>
    </Container>
  );
}

export default SessionExpired;
